import apiUrl from "../../../../utils/settings";

export const onboardCompanyRoleUrl = () => {
  return apiUrl + '/onboarding/company-and-role';
};
export const getLocationAndPincodeUrl = () => {
  return apiUrl + '/location-and-pincode/by-district';
};

export const firmOnboardingUrl = () => {
  return apiUrl + '/onboarding/firm';
};

